import { useEffect } from "react";
import HomeHeader from "../../components/DashBoardComponents/Home/HomeHeader/index";
import HomeBalance from "../../components/DashBoardComponents/Home/HomeBalances/index";
import HomeProductSection from "../../components/DashBoardComponents/Home/HomeProduct/index";
import Chart from "../../components/DashBoardComponents/Home/HomeChart/index";
import HomeBigChat from "../../components/DashBoardComponents/Home/HomeBigChart/index";
import {
  BalanceContainer,
  OurProductContainer,
  ChatContainer,
} from "./home.styles";
import { HomeSpan } from "../../components/DashBoardComponents/Home/HomeBalances/homeBalance.styles";
import { useQuery } from "@apollo/client";
import { getUserBankDetails } from "../../graphql/queries/accounts";
import { styled } from "styled-components";
import CompleteAccount from "../../components/DashBoardComponents/Home/CompleteAccount";
import { LoadingSpinner } from "../AddUserPage/AddUser";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { RootState } from "../../store/rootReducer";
import { useLocation } from "react-router-dom";
import { fetchFormResponses } from "../../store/onBoarding/onBoardingSlice";
import {
  setFirstModalOpen,
  setSecondModalOpen,
} from "../../store/modal/modalSlice";
import WelcomeModal from "../../components/WelcomeToFipayModal/WelcomeModal";
import HomeProduct from "../../components/DashBoardComponents/Home/HomeProductModal";

const Index = () => {
  const { pathname } = useLocation();
  const { data: queryData, refetch: refetchUserBankDetails } =
    useQuery(getUserBankDetails);

  const userBankDetails = queryData?.getUserBankDetails || {};
  const checkerArr = Object.keys(userBankDetails);

  const dispatch = useAppDispatch();

  const handleSkipTutorial = () => {
    dispatch(setFirstModalOpen(false));
    // dispatch(setSecondModalOpen(true));
    // dispatch(setFirstModalOpen(false));
    // dispatch(setSecondModalOpen(true));
  };

  const { firstModalOpen, secondModalOpen } = useSelector(
    (state: RootState) => state.modal
  );
  const handleSkipSecondModal = () => {
    dispatch(setSecondModalOpen(false));
  };

  const { formResponses, loading } = useSelector(
    (state: RootState) => state.OnBoarding
  );
  const isReviewed = formResponses?.reviewed;

  useEffect(() => {
    dispatch(fetchFormResponses());
  }, [dispatch, pathname]);
  return (
    <>
      <HomeWrapper>
        <HomeHeader />
        {checkerArr.length === 0 && !loading ? (
          // Show CompleteAccount when userBankDetails is empty
          <>{!isReviewed && <CompleteAccount />}</>
        ) : (
          <>
            {checkerArr.length === 0 || loading ? (
              <AccountContainer>
                <LoadingSpinner small />
              </AccountContainer>
            ) : (
              <>
                <AccountContainer>
                  <BalanceWrapper>
                    <HomeSpan>Balances</HomeSpan>
                    <BalanceContainer>
                      <HomeBalance />
                    </BalanceContainer>
                  </BalanceWrapper>
                </AccountContainer>
              </>
            )}
          </>
        )}
        <OurProductContainer>
          <HomeProductSection />
        </OurProductContainer>
        <ChatContainer>
          <Chart />
        </ChatContainer>
        <ChatContainer>
          <HomeBigChat />
        </ChatContainer>
      </HomeWrapper>
      {firstModalOpen && (
        <WelcomeModal handleSkipTutorial={handleSkipTutorial} />
      )}
      {/* {secondModalOpen && <HomeProduct handleSkip={handleSkipSecondModal} />}
      {firstModalOpen && (
        <WelcomeModal handleSkipTutorial={handleSkipTutorial} />
      )}
      {secondModalOpen && <HomeProduct handleSkip={handleSkipSecondModal} />} */}
    </>
  );
};

export default Index;

export const HomeWrapper = styled.div`
  width: 78vw;
  @media only screen and (max-width: 768px) {
    width: 100vw;
  }
`;
export const BalanceWrapper = styled.div`
  width: 100%;
`;
export const AccountContainer = styled.div`
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
  }
`;
